const isParentNavEnabled = false;

export default [
    {
        path: "mari",
        name: "mari",
        redirect: "home",
    },
    {
        path: "home",
        name: "home",
        component: () =>
            import(/* webpackChunkName: "mari-home" */ "../views/Home.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "request/:id",
        name: "request",
        component: () =>
            import(/* webpackChunkName: "mari-home" */ "../views/Request.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MarUser",
        name: "Users",
        component: () =>
            import(/* webpackChunkName: "mari-user" */ "../views/MarUser.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/Approver",
        name: "Approver",
        component: () =>
            import(/* webpackChunkName: "mari-approver" */ "../views/MasterData/Approver.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/General",
        name: "General",
        component: () =>
            import(/* webpackChunkName: "mari-General" */ "../views/MasterData/General.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/Classification",
        name: "Classification",
        component: () =>
            import(/* webpackChunkName: "mari-MasterData-Classification" */ "../views/MasterData/Classification.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/Contract",
        name: "Contract",
        component: () =>
            import(/* webpackChunkName: "mari-MasterData-Contract" */ "../views/MasterData/Contract.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/DeviceType",
        name: "DeviceType",
        component: () =>
            import(/* webpackChunkName: "mari-MasterData-DeviceType" */ "../views/MasterData/DeviceType.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/Product",
        name: "Product",
        component: () =>
            import(/* webpackChunkName: "mari-MasterData-Product" */ "../views/MasterData/Product.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "MasterData/RouteOfAdministration",
        name: "RouteOfAdministration",
        component: () =>
            import(/* webpackChunkName: "mari-MasterData-RouteOfAdministration" */ "../views/MasterData/RouteOfAdministration.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "NoAccess",
        name: "NoAccess",
        component: () =>
            import(/* webpackChunkName: "mari-NoAccess" */ "../views/NoAccess.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
    {
        path: "Report/RequestInfo",
        name: "Request Info",
        component: () =>
            import(/* webpackChunkName: "mari-Report-RequestInfo" */ "../views/Report/RequestInfo.vue"),
        meta: {
            mainNavEnabled: isParentNavEnabled,
        },
    },
];